const ERCABI = [
    "function balanceOf(address)view returns(uint)",
    "function transfer(address to,uint amount) returns(bool)",
    "function symbol()external view returns(string memory)",
    "function name()external view returns(string memory)"
]

module.exports={ERCABI}